export const Status = Object.freeze({
  VERIFIED: 'verified',
  UNKNOWN: 'unknown',
  UNVERIFIED: 'unverified',
})
